import {defaultPicture} from "./../../../utils/index";

export const userInfoReducer = (state = { avatar: defaultPicture }, action) => {
  switch (action.type) {
    case "SET_USER_INFO":
      return action.payload;
    case "CLEAR_USER_INFO":
      return action.payload;
    default:
      return state;
  }
};
